import { keyframes } from '@emotion/react';
import { css } from '@emotion/react';
import { FC } from 'react';

const pulse = keyframes({
  '0%': {
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 0.4)',
  },
  '70%': {
    boxShadow: '0 0 0 6px rgba(0, 0, 0, 0)',
  },
  '100%': {
    boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)',
  },
});

export const PositionMarker: FC = () => <div css={styles.marker} />;

const styles = {
  marker: css({
    display: 'block',
    width: '20px',
    height: '20px',
    borderRadius: '50%',
    background: 'black',
    left: 'calc(50% - 20px / 2)',
    top: 'calc(50% - 20px / 2)',
    position: 'absolute',
    boxShadow: '0 0 0 rgba(0, 0, 0, 0.4)',
    border: '3px solid rgba(255, 255, 255, 0.95)',
    animation: `${pulse} 1.5s infinite`,
  }),
};
